let subscribers = {};
// Last payload of every event that has already fired. pubsub.js is deferred while
// the publishers are inline section scripts driven by API responses, so an event
// can fire before a late subscriber's own script has run; subscribeSticky()
// replays it for those subscribers instead of losing them to the race.
let publishedEvents = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

// subscribe(), but if the event was already published the callback runs right
// away with the last payload — so subscribing late is no longer a lost event.
function subscribeSticky(eventName, callback) {
  const unsubscribe = subscribe(eventName, callback);

  if (Object.prototype.hasOwnProperty.call(publishedEvents, eventName)) {
    callback(publishedEvents[eventName]);
  }

  return unsubscribe;
}

function publish(eventName, data) {
  publishedEvents[eventName] = data;

  if (subscribers[eventName]) {
    const promises = subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
